export default function(ac, app) {
    var cjenik = app.getEntity('Cjenik');

    cjenik
        .listView()
        .title('Cjenici')
        .icon('<i class="fa fa-money fa-3x"></i>');

    cjenik
        .editionView()
        .title('Cjenik')
        .fields([
            {
                key: 'naziv',
                type: 'hInput',
                templateOptions: {
                    label: 'Naziv cjenika',
                    required: true,
                    focus: true
                }
            },
            {
                key: 'valuta',
                type: 'huiSelect',
                templateOptions: {
                    label: 'Valuta',
                    optionsAttr: 'bs-options',
                    ngOptions: 'option[to.valueProp] as option in to.options | filter: $select.search',
                    valueProp: 'id',
                    labelProp: 'valuta',
                    placeholder: 'Odaberite valutu',
                    options: []
                },
                controller: [
                    '$scope',
                    'DS',
                    function($scope, DS) {
                        $scope.to.options = DS.getAll('Valuta');
                        DS.findAll('Valuta').then(function(response) {
                            $scope.to.options = response;
                        });
                    }
                ]
            }
        ]);

    var stavkaCjenika = app.getEntity('StavkaCjenika');

    stavkaCjenika
        .listView()
        .title(function(entry) {
            return `Cjenik ${entry.naziv}`;
        })
        .description('Registar cjenika')
        .icon('<i class="fa fa-archive fa-3x"></i>')
        .fields([
            ac
                .field('protetski_rad', 'reference')
                .label('Naziv protetskog rada / usluge ')
                .targetEntity(app.getEntity('ProtetskiRad'))
                .targetField(ac.field('naziv')),

            ac
                .field('porezna_stopa', 'reference')
                .label('Porezna tarifa')
                .targetEntity(app.getEntity('PoreznaStopa'))
                .targetField(
                    ac.field('naziv', 'template').template(function(entry) {
                        return `${entry.naziv}`;
                    })
                ),

            ac.field('iznos')
        ])
        .listActions(['edit', 'delete']);

    stavkaCjenika
        .creationView()
        .title('Unos nove stavke cjenika')
        .fields([
            {
                key: 'protetski_rad',
                type: 'huiSelect',
                templateOptions: {
                    label: 'Protetski rad',
                    optionsAttr: 'bs-options',
                    ngOptions: 'option[to.valueProp] as option in to.options | filter: $select.search',
                    valueProp: 'id',
                    labelProp: 'naziv',
                    placeholder: 'Odaberite uslugu',
                    options: [],
                    required: true
                },
                controller: [
                    '$scope',
                    'DS',
                    function($scope, DS) {
                        DS.findAll('ProtetskiRad').then(function(response) {
                            $scope.to.options = response;
                        });
                    }
                ]
            },

            {
                key: 'porezna_stopa',
                type: 'huiSelect',
                templateOptions: {
                    label: 'Porezna stopa',
                    optionsAttr: 'bs-options',
                    ngOptions: 'option[to.valueProp] as option in to.options | filter: $select.search',
                    valueProp: 'id',
                    labelProp: 'naziv',
                    placeholder: 'Odaberite stopu',
                    options: [],
                    required: true
                },
                controller: [
                    '$scope',
                    'DS',
                    function($scope, DS) {
                        DS.findAll('PoreznaStopa').then(function(response) {
                            $scope.to.options = response;
                        });
                    }
                ]
            },

            {
                key: 'iznos',
                type: 'hInput',
                templateOptions: {
                    label: 'Iznos'
                }
            }
        ]);

    return cjenik;
}



// WEBPACK FOOTER //
// ./app/components/cjenik/config.js